const gettext = (text) => {
	return text;
};

export {gettext};